module.exports = __webpack_public_path__ + "static/media/header-right.836dd976.png";